import actions from '@/core/store/tipo/actions'
import mutations from '@/core/store/tipo/mutations'
import state from '@/core/store/tipo/state'

export default { actions, mutations, state }
